import { Pipe, PipeTransform } from '@angular/core';

/**
 * Repairs the logo URLs the college/authority autocomplete returns.
 *
 * Those records wrap a Clearbit logo URL inside Google's favicon `domain=`
 * parameter, which expects a bare hostname:
 *
 *   .../s2/favicons?domain=https://logo.clearbit.com/harvard.edu/&sz=128
 *
 * Google cannot resolve that as a domain, answers 404 and serves its 16x16
 * grey globe, so no university logo ever appears. Unwrapping the hostname
 * gives the same service the bare domain it wants and the real crest comes
 * back. Clearbit's own free logo API is gone as well, so a plain Clearbit URL
 * is redirected the same way. Company URLs already carry a bare domain and
 * pass through untouched.
 */
@Pipe({ name: 'logoUrl' })
export class LogoUrlPipe implements PipeTransform {
	transform(url: string | null | undefined): string {
		if (!url) return '';
		const clearbit = /logo\.clearbit\.com\/([^/&?#]+)/i.exec(url);
		if (clearbit) {
			return `https://www.google.com/s2/favicons?domain=${clearbit[1]}&sz=128`;
		}
		return url;
	}
}

/** Same repair for the TypeScript side, where a value is saved rather than shown. */
export function normalizeLogoUrl(url: string | null | undefined): string {
	return new LogoUrlPipe().transform(url);
}
